module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "modal--small",
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Izmeni porudžbinu za - " + _vm._s(_vm.title))]), _vm._v(" "), _c('i', {
    staticClass: "ti-close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Vreme preuzimanja")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPrepTime),
      expression: "newPrepTime"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "number",
      "name": "preTime"
    },
    domProps: {
      "value": (_vm.newPrepTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPrepTime = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.selectedVoucher == null) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cena")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPrice),
      expression: "newPrice"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "number",
      "name": "newPrice"
    },
    domProps: {
      "value": (_vm.newPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPrice = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payByCredit),
      expression: "payByCredit"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox2",
      "name": "users"
    },
    domProps: {
      "checked": Array.isArray(_vm.payByCredit) ? _vm._i(_vm.payByCredit, null) > -1 : (_vm.payByCredit)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.payByCredit,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.payByCredit = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.payByCredit = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.payByCredit = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('span', [_c('label', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "for": "checkbox2"
    }
  }, [_vm._v("Plaćanje kreditom ")])])]), _vm._v(" "), _c('div', [_c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*Napomena: ukoliko otkačite ovo, kompaniji ce se skinuti broj kredita iz polja za cenu")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Komentar")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newComment),
      expression: "newComment"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "comment"
    },
    domProps: {
      "value": (_vm.newComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newComment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Broj od kupca")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customerPhoneNumber),
      expression: "customerPhoneNumber"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "type": "text",
      "name": "customerPhoneNumber"
    },
    domProps: {
      "value": (_vm.customerPhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerPhoneNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.order != null && _vm.order.orderPrice != null && _vm.order.orderPrice > 0) ? _c('label', [_vm._v("Cena poruzbine " + _vm._s(_vm.order.orderPrice) + " RSD")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError.length !== 0),
      expression: "hasError.length !== 0"
    }],
    staticClass: "foo"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.hasError))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [(!_vm.isLoading) ? _c('input', {
    staticClass: "input",
    staticStyle: {
      "background": "#2b542c"
    },
    attrs: {
      "type": "button",
      "placeholder": "Ažuriraj",
      "name": "azuriraj",
      "value": "Ažuriraj"
    },
    on: {
      "click": function($event) {
        return _vm.updateDriver()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "loader",
    staticStyle: {
      "width": "36px",
      "height": "36px"
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66824954!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/EditOrderModal.vue
// module id = 489
// module chunks = 1